var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ChatState_instances, _ChatState_onStateChange, _ChatState_throttledOnStateChange, _ChatState_messagesState, _ChatState_reactionsState, _ChatState_previouslyPublishedState, _ChatState_updateState;
import { MessagesState, isNotOptimisticMessage, } from "./messagesState";
import { ReactionsState } from "./reactionsState";
import { throttleTrailing } from "./util/debounce";
export const DEFAULT_LIVE_MAX_CHAT_MESSAGES = 150;
export const DEFAULT_REPLAY_MAX_CHAT_MESSAGES = 1000;
export const DEFAULT_STATE_CHANGE_THROTTLE_MS = 250;
export class ChatState {
    constructor(onStateChange, { maxChatMessages = DEFAULT_LIVE_MAX_CHAT_MESSAGES, onStateChangeThrottleMs = DEFAULT_STATE_CHANGE_THROTTLE_MS, onDuplicateMessage = () => { }, } = {}) {
        _ChatState_instances.add(this);
        _ChatState_onStateChange.set(this, void 0);
        _ChatState_throttledOnStateChange.set(this, void 0);
        _ChatState_messagesState.set(this, void 0);
        _ChatState_reactionsState.set(this, new ReactionsState()
        // Track the previously published state so that we can provide this to onStateChange
        );
        // Track the previously published state so that we can provide this to onStateChange
        _ChatState_previouslyPublishedState.set(this, {
            messages: new Map(),
            reactions: {},
        });
        this.clear = () => {
            __classPrivateFieldGet(this, _ChatState_messagesState, "f").clear();
            __classPrivateFieldGet(this, _ChatState_reactionsState, "f").clear();
            __classPrivateFieldGet(this, _ChatState_instances, "m", _ChatState_updateState).call(this, true);
        };
        this.addMessage = (message) => {
            const newMessage = __classPrivateFieldGet(this, _ChatState_messagesState, "f").add(message);
            __classPrivateFieldGet(this, _ChatState_instances, "m", _ChatState_updateState).call(this, !isNotOptimisticMessage(message));
            return newMessage;
        };
        this.addMessageBatch = (batch, range) => {
            __classPrivateFieldGet(this, _ChatState_messagesState, "f").addBatch(batch, range);
            if (batch.length) {
                __classPrivateFieldGet(this, _ChatState_instances, "m", _ChatState_updateState).call(this);
            }
        };
        this.addMessageBatchWithReactions = (batch, range) => {
            __classPrivateFieldGet(this, _ChatState_messagesState, "f").addBatch(batch, range);
            __classPrivateFieldGet(this, _ChatState_reactionsState, "f").addBatch(batch);
            if (batch.length) {
                __classPrivateFieldGet(this, _ChatState_instances, "m", _ChatState_updateState).call(this);
            }
        };
        this.removeMessage = (messageKeyOrTimetoken, optimistic = false) => {
            const removedMessage = __classPrivateFieldGet(this, _ChatState_messagesState, "f").remove(messageKeyOrTimetoken);
            const removedReactions = typeof messageKeyOrTimetoken === "bigint"
                ? __classPrivateFieldGet(this, _ChatState_reactionsState, "f").removeAll(messageKeyOrTimetoken)
                : undefined;
            if (optimistic || removedMessage || removedReactions) {
                __classPrivateFieldGet(this, _ChatState_instances, "m", _ChatState_updateState).call(this, optimistic);
            }
            return removedMessage;
        };
        this.addReaction = (args) => {
            const change = __classPrivateFieldGet(this, _ChatState_reactionsState, "f").add(args);
            __classPrivateFieldGet(this, _ChatState_instances, "m", _ChatState_updateState).call(this, args.isOptimistic);
            return change;
        };
        this.removeReaction = (args) => {
            const change = __classPrivateFieldGet(this, _ChatState_reactionsState, "f").remove(args);
            __classPrivateFieldGet(this, _ChatState_instances, "m", _ChatState_updateState).call(this, args.isOptimistic);
            return change;
        };
        this.getReactionTimetoken = (messageTimetoken, reactionKey) => {
            return __classPrivateFieldGet(this, _ChatState_reactionsState, "f").getReactionTimetoken(messageTimetoken, reactionKey);
        };
        this.getLoadedRangeIntersecting = (timetoken) => __classPrivateFieldGet(this, _ChatState_messagesState, "f").getLoadedRangeIntersecting(timetoken);
        console.assert(maxChatMessages > 0, `Expected maxChatMessage > 0 but found ${maxChatMessages}`);
        console.assert(onStateChangeThrottleMs >= 0, `Expected onStateChangeThrottleMs >= 0 but found ${onStateChangeThrottleMs}`);
        __classPrivateFieldSet(this, _ChatState_onStateChange, onStateChange, "f");
        if (onStateChangeThrottleMs) {
            __classPrivateFieldSet(this, _ChatState_throttledOnStateChange, throttleTrailing(onStateChange, onStateChangeThrottleMs), "f");
        }
        __classPrivateFieldSet(this, _ChatState_messagesState, new MessagesState({
            maxChatMessages,
            onDuplicateMessage,
        }), "f");
    }
    truncateFetchRange(range) {
        return __classPrivateFieldGet(this, _ChatState_messagesState, "f").truncateFetchRange(range);
    }
    get state() {
        return __classPrivateFieldGet(this, _ChatState_previouslyPublishedState, "f");
    }
}
_ChatState_onStateChange = new WeakMap(), _ChatState_throttledOnStateChange = new WeakMap(), _ChatState_messagesState = new WeakMap(), _ChatState_reactionsState = new WeakMap(), _ChatState_previouslyPublishedState = new WeakMap(), _ChatState_instances = new WeakSet(), _ChatState_updateState = function _ChatState_updateState(optimistic = false) {
    const prevState = __classPrivateFieldGet(this, _ChatState_previouslyPublishedState, "f");
    const newState = {
        messages: __classPrivateFieldGet(this, _ChatState_messagesState, "f").state,
        reactions: __classPrivateFieldGet(this, _ChatState_reactionsState, "f").state,
    };
    __classPrivateFieldSet(this, _ChatState_previouslyPublishedState, newState, "f");
    if (optimistic || !__classPrivateFieldGet(this, _ChatState_throttledOnStateChange, "f")) {
        __classPrivateFieldGet(this, _ChatState_onStateChange, "f").call(this, newState, prevState);
    }
    else {
        __classPrivateFieldGet(this, _ChatState_throttledOnStateChange, "f").call(this, newState, prevState);
    }
};
export function assertNotOptimistic(message) {
    if (!isNotOptimisticMessage(message)) {
        throw new Error("Expected message to not be optimistic");
    }
}
